/*
  bmp-label-guard.js  (2026-08-31)

  Keeps the pre-order button labelled "Pre Order" after a variant change.

  THE BUG. snippets/buy-buttons.liquid renders the label server-side by calling
  bm-preorder in 'label' mode, so the FIRST paint is correct. When the customer
  changes variant, the theme re-renders the buy box and rewrites the button text
  from window.variantStrings.addToCart, overwriting that server-rendered label.
  The customer then sees "Add to Cart" on a variant that is genuinely on
  pre-order, with its dispatch date printed directly above the button.

  WHY IT LIVES HERE. A previous attempt patched bm-preorder.liquid directly and
  blanked the entire widget, so that file is deliberately untouched. This is a
  read-only guard: it never renders the widget, never decides buyability, and
  never enables a purchase. It only restores a label the server already chose.

  WHY NOT A characterData OBSERVER. The theme assigns textContent to the SAME
  span, so the change is characterData rather than childList. Observing
  characterData while writing characterData re-enters, which is the failure mode
  behind the sitewide VAT-toggle incident, so this drives off the variant change
  event and re-applies across a few frames instead. apply() is idempotent: it
  only ever rewrites text that exactly matches the theme's add-to-cart wording.

  HOW IT KNOWS. bm-preorder already emits, per product page:
      var BMP_PRE_BTN = "Pre Order";                 (localised)
      var BMP_MAP = { "<variant_id>": { label_preorder: true, ... }, ... }
  Both are scoped inside its own IIFE, so they are parsed out of the document
  once rather than read off window. If either is absent (any page without a
  pre-order box, e.g. the Nano) this file is inert.
*/
(function () {
  "use strict";

  var BTN = ".product-form__submit";
  var html = null;
  var map = null;
  var preLabel = null;

  function source() {
    if (html === null) html = document.documentElement.innerHTML;
    return html;
  }

  function labelMap() {
    if (map !== null) return map;
    map = {};
    try {
      var m = source().match(/BMP_MAP\s*=\s*(\{[\s\S]*?\});/);
      if (m) map = JSON.parse(m[1]) || {};
    } catch (e) {
      map = {};
    }
    return map;
  }

  function preOrderLabel() {
    if (preLabel !== null) return preLabel;
    preLabel = "";
    try {
      var m = source().match(/BMP_PRE_BTN\s*=\s*"([^"]+)"/);
      if (m) preLabel = m[1];
    } catch (e) {
      preLabel = "";
    }
    return preLabel;
  }

  function selectedVariantId() {
    var btn = document.querySelector(BTN);
    var form = btn && btn.closest("form");
    var field =
      (form && form.querySelector('[name="id"]')) ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');
    return field ? String(field.value) : null;
  }

  function apply() {
    var label = preOrderLabel();
    if (!label) return;

    var vid = selectedVariantId();
    if (!vid) return;

    var entry = labelMap()[vid];
    if (!entry || !entry.label_preorder) return;

    var btn = document.querySelector(BTN);
    if (!btn) return;

    var target = btn.querySelector("span") || btn;
    var text = (target.textContent || "").replace(/\s+/g, " ").trim();
    if (!text || text === label) return;

    // Only ever replace the theme's own add-to-cart wording. Never touch
    // "Sold out", "Unavailable", or anything a human deliberately set.
    var addToCart = "";
    try {
      addToCart = ((window.variantStrings || {}).addToCart || "").trim();
    } catch (e) {
      addToCart = "";
    }
    if (!((addToCart && text === addToCart) || /^add to (cart|bag)$/i.test(text))) return;

    target.textContent = label;
  }

  // The theme swaps the buy box asynchronously and can settle over several
  // frames, so re-apply across a short window rather than guessing one moment.
  function applySoon() {
    apply();
    [0, 60, 150, 320, 600, 1000, 1600].forEach(function (ms) {
      window.setTimeout(apply, ms);
    });
  }

  function boot() {
    applySoon();

    // Variant pickers are radios or a select inside the product form.
    document.addEventListener("change", function (event) {
      var t = event.target;
      if (!t || !t.closest) return;
      if (t.closest('form[action*="/cart/add"]') || t.closest("variant-radios, variant-selects, .product-form")) {
        applySoon();
      }
    }, true);

    // Themes commonly announce the swap; harmless if never fired.
    ["variant:change", "on:variant:change", "product:variant-change"].forEach(function (name) {
      document.addEventListener(name, applySoon, true);
    });

    // Still watch for the buy box being REPLACED wholesale (childList only).
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        apply();
      });
    }).observe(document.body, { subtree: true, childList: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
